import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        //currentModelPath: "",
        currentAnimationName: "No Animation",
        isAnimationPlaying: false,

        numberOfFrames: 10,
        captureWidth: 1024,
        captureHeight: 1024,
        isCaptureVisible: true,
        isCaptureNormals: true,
        postProcessingShaders: [],

        isShowSkeleton: false,
        isShowWireframe: false,
        isShowGrid: false,
        isShowNormals: false,
        isAntiAlias: true,
        canvasZoom: 1,

        lightSettings: {
            isLightsEnabled: true,
            ambientIntensity: 1,
            directIntensity: 1,
            directColor: "#FFFFFF",
            ambientColor: "#FFFFFF",
            textureEncoding: "sRGB",
            outputEncoding: "sRGB",
            toneMappingExposure: 1.0,
            isEnvironmentEnabled: true,
            directLightPosition: {
                x: 0,
                y: 0,
                z: 0,
            },

            directLightRotation: {
                x: 0,
                y: 0,
                z: 0,
            },

            isShowDirectionalLight: false,
        },

        transformSettings: {
            rotationSettings: {
                x: 0,
                y: 0,
                z: 0,
            },
            scaleSettings: {
                x: 1,
                y: 1,
                z: 1,
            },
        },

        currentEffect: "No Effect",
        effectSettings: {},

        currentMaterial: null,
        backgroundColor: "#121212",

        isPostProcessingEnabled: true,
    },
    mutations: {
        //setCurrentModelPath(state, modelPath) {
        //    state.currentModelPath = modelPath;
        //},
        setCurrentAnimationName(state, currentAnimationName) {
            state.currentAnimationName = currentAnimationName;
        },
        setNumberOfFrames(state, numberOfFrames) {
            state.numberOfFrames = numberOfFrames;
        },
        setCaptureWidth(state, captureWidth) {
            state.captureWidth = captureWidth;
        },
        setCaptureHeight(state, captureHeight) {
            state.captureHeight = captureHeight;
        },
        setIsCaptureVisible(state, isCaptureVisible) {
            state.isCaptureVisible = isCaptureVisible;
        },
        setIsCaptureNormals(state, value) {
            state.isCaptureNormals = value;
        },
        addPostProcessingShader(state, newShader) {
            state.postProcessingShaders.push(newShader);
            let tmp = state.postProcessingShaders;
            state.postProcessingShaders = tmp;
        },
        removePostProcessingShader(state, shader) {
            let shaderIndex = state.postProcessingShaders.indexOf(shader);
            state.postProcessingShaders.splice(shaderIndex, 1);
            let tmp = state.postProcessingShaders;
            state.postProcessingShaders = tmp;
        },
        updateShadersParameters(state) {
            //We change the shader object but it is not updated
            //Because Vue doesn't keep track of array params
            //So each update to a parameter we manually update via this function
            //In my opinion - Better then deepcopying the shaders array each time
            state.postProcessingShaders.push(null);
            state.postProcessingShaders.pop();
        },

        setIsShowSkeleton(state, isShow) {
            state.isShowSkeleton = isShow;
        },
        setIsShowWireframe(state, isShow) {
            state.isShowWireframe = isShow;
        },
        setIsShowGrid(state, isShow) {
            state.isShowGrid = isShow;
        },
        setIsShowNormals(state, isShow) {
            state.isShowNormals = isShow;
        },
        setIsLightsEnabled(state, isEnabled) {
            state.lightSettings.isLightsEnabled = isEnabled;
            state.lightSettings = {...state.lightSettings};
        },
        setAmbientIntensity(state, value) {
            state.lightSettings.ambientIntensity = value;
            state.lightSettings = {...state.lightSettings};
        },
        setDirectIntensity(state, value) {
            state.lightSettings.directIntensity = value;
            state.lightSettings = {...state.lightSettings};
        },
        setDirectColor(state, value) {
            state.lightSettings.directColor = value;
            state.lightSettings = {...state.lightSettings};
        },
        setDirectLightPosition(state, value) {
            state.lightSettings.directLightPosition.x = value.x;
            state.lightSettings.directLightPosition.y = value.y;
            state.lightSettings.directLightPosition.z = value.z;

            state.lightSettings = {...state.lightSettings};
        },
        setDirectLightRotation(state, value) {
            state.lightSettings.directLightRotation.x = value.x;
            state.lightSettings.directLightRotation.y = value.y;
            state.lightSettings.directLightRotation.z = value.z;

            state.lightSettings = {...state.lightSettings};
        },
        setIsShowDirectionalLight(state, value) {
            state.lightSettings.isShowDirectionalLight = value;
            state.lightSettings = {...state.lightSettings};
        },
        setAmbientColor(state, value) {
            state.lightSettings.ambientColor = value;
            state.lightSettings = {...state.lightSettings};
        },
        setTextureEncoding(state, value) {
            state.lightSettings.textureEncoding = value;
            state.lightSettings = {...state.lightSettings};
        },
        setOutputEncoding(state, value) {
            state.lightSettings.outputEncoding = value;
            state.lightSettings = {...state.lightSettings};
        },
        setToneMappingExposure(state, value) {
            state.lightSettings.toneMappingExposure = value;
            state.lightSettings = {...state.lightSettings};
        },
        setIsEnvironmentEnabled(state, value) {
            state.lightSettings.isEnvironmentEnabled = value;
            state.lightSettings = {...state.lightSettings};
        },
        setCanvasZoom(state, value) {
            state.canvasZoom = value;
        },
        setCurrentMaterial(state, value) {
            state.currentMaterial = value;
        },
        setCurrentEffect(state, value) {
            state.currentEffect = value;
        },
        setEffectSettings(state, value) {
            state.effectSettings = {...value};
        },
        setIsAntiAlias(state, value) {
            state.isAntiAlias = value;
        },
        setTransformSettings(state, values) {
            state.transformSettings.scaleSettings.x = values.scaleX;
            state.transformSettings.scaleSettings.y = values.scaleY;
            state.transformSettings.scaleSettings.z = values.scaleZ;
            state.transformSettings.rotationSettings.x = values.rotationX;
            state.transformSettings.rotationSettings.y = values.rotationY;
            state.transformSettings.rotationSettings.z = values.rotationZ;
            state.transformSettings = { ...state.transformSettings };
        },
        setBackgroundColor(state, value) {
            state.backgroundColor = value;
        },
        setIsPostProcessingEnabled(state, value) {
            state.isPostProcessingEnabled = value;
        },
        changeShadersOrder(state, values) {
            var fromIndex = values["fromIndex"];
            var toIndex = values["toIndex"];
            if (fromIndex == toIndex) {
                return false;
            }
            if (fromIndex + 1 == toIndex) {
                return false;
            }
            if (fromIndex < 0 || fromIndex >= state.postProcessingShaders.length) {
                return false;
            }
            var element = null;
            if (toIndex == state.postProcessingShaders.length) {
                //Move the Item to be last
                //console.log("Moving to the end");
                element = state.postProcessingShaders[fromIndex];
                state.postProcessingShaders.splice(fromIndex, 1);
                state.postProcessingShaders.push(element);
            } else {
                if (toIndex == 0) {
                    //Move the Item to be first
                    //console.log("Moving to the begginining");
                    element = state.postProcessingShaders[fromIndex];
                    state.postProcessingShaders.splice(fromIndex, 1);
                    state.postProcessingShaders.unshift(element);
                } else {
                    //Regular case, from index in the middle to index in the middle
                    //console.log("Moving to the middle");
                    element = state.postProcessingShaders[fromIndex];
                    if (fromIndex < toIndex) {
                        state.postProcessingShaders.splice(fromIndex, 1);
                        state.postProcessingShaders.splice(toIndex - 1, 0, element);
                    } else {
                        state.postProcessingShaders.splice(fromIndex, 1);
                        state.postProcessingShaders.splice(toIndex, 0, element);
                    }
                }
            }
            
            let tmp = state.postProcessingShaders;
            state.postProcessingShaders = tmp;
            return true;
        },
    },
});
